import client from '../api';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancel;
let autoFillingVariablesCancel;

export const getFromById = async (id) => {
  if (cancel !== undefined) {
    cancel();
  }

  const params = { status: 'all' };

  const response = await client.get(`api/corporate-library/forms/${id}/`, {
    params,
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });

  return response.data;
};
export const getPublicForm = async (id) => {
  if (cancel !== undefined) {
    cancel();
  }

  const response = await client.get(`/api/initiated-form/${id}/get-form-view/`, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });

  return response.data;
};

export const getPublicFormPDF = async (id, body) => {
  if (cancel !== undefined) {
    cancel();
  }

  return await client.post(`/api/initiated-form/${id}/generate-pdf/`, body, {
    responseType: 'blob',
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const getFormPDF = async (id, body) => {
  if (cancel !== undefined) {
    cancel();
  }

  return await client.post(`api/corporate-library/forms/${id}/generate-pdf/`, body, {
    responseType: 'blob',
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const getGeneralFormPDF = async (id, body) => {
  if (cancel !== undefined) {
    cancel();
  }

  return await client.post(`api/general-library/forms/${id}/generate-pdf/`, body, {
    responseType: 'blob',
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const getGeneralFromById = async (id, params) => {
  if (cancel !== undefined) {
    cancel();
  }

  const response = await client.get(`api/general-library/forms/${id}/`, {
    params,
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });

  return response.data;
};
export const getInitFromById = async (id, token, submissionId, submissionNotificationId) => {
  if (cancel !== undefined) {
    cancel();
  }

  const params = {};

  if (token) {
    params['token'] = token;
  }

  // Forms with a strict order and multiple submissions fan out into one submission
  // per first-step user, so the caller has to say which one it is opening.
  if (submissionId) {
    params['submission'] = submissionId;
  }

  // Opened from a "Sent" row of the Submissions folder: the form is served as the
  // submitter that row is waiting on, not as the caller.
  if (submissionNotificationId) {
    params['submission_notification'] = submissionNotificationId;
  }

  const response = await client.get(`api/initiated-form/${id}/get-form/`, {
    params,
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });

  return response.data;
};

export const updateForm = async (id, data) => {
  if (cancel !== undefined) {
    cancel();
  }

  const response = await client.patch(`api/corporate-library/forms/${id}/`, data, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });

  return response.data;
};
export const updateFormAdmin = async (id, data) => {
  if (cancel !== undefined) {
    cancel();
  }

  const response = await client.patch(`api/general-library/forms/${id}/`, data, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });

  return response.data;
};

export const createForm = async (data) => {
  if (cancel !== undefined) {
    cancel();
  }

  const response = await client.post(`api/corporate-library/forms/`, data, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });

  return response.data;
};
export const createFormAdmin = async (data) => {
  if (cancel !== undefined) {
    cancel();
  }

  const response = await client.post(`api/general-library/forms/`, data, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });

  return response.data;
};

export const shareWithCompany = async (data) => {
  if (cancel !== undefined) {
    cancel();
  }

  const response = await client.post(`/api/general-library/forms/share-with-company/`, data, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });

  return response.data;
};

export const initForm = async (data, id) => {
  if (cancel !== undefined) {
    cancel();
  }

  const response = await client.post(`api/corporate-library/forms/initiate/${id}/initialize/`, data, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });

  return response.data;
};

export const saveMandatoryForm = async (id, data) => {
  if (cancel !== undefined) {
    cancel();
  }

  const response = await client.post(`api/corporate-library/forms/initiate/${id}/mandatory-save/`, data, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });

  return response.data;
};

export const deactivateForm = async (id) => {
  if (cancel !== undefined) {
    cancel();
  }

  const response = await client.delete(`api/corporate-library/forms/${id}/`, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });

  return response.data;
};

export const deactivateGeneralForm = async (id) => {
  if (cancel !== undefined) {
    cancel();
  }

  const response = await client.delete(`api/general-library/forms/${id}/`, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });

  return response.data;
};

export const deleteGeneralForm = async (id) => {
  if (cancel !== undefined) {
    cancel();
  }

  const response = await client.delete(`api/general-library/forms/${id}/hard-delete/`, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });

  return response;
};

export const activateForm = async (id) => {
  if (cancel !== undefined) {
    cancel();
  }

  const response = await client.patch(
    `api/corporate-library/forms/${id}/restore/`,
    {},
    {
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
    },
  );

  return response.data;
};
export const activateGeneralForm = async (id) => {
  if (cancel !== undefined) {
    cancel();
  }

  const response = await client.patch(
    `api/general-library/forms/${id}/restore/`,
    {},
    {
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
    },
  );

  return response.data;
};

export const submitForm = async (id, data, token, submissionId, submissionNotificationId) => {
  if (cancel !== undefined) {
    cancel();
  }

  const params = {};

  if (token) {
    params['token'] = token;
  }

  if (submissionId) {
    params['submission'] = submissionId;
  }

  // Submitted on behalf of the submitter a "Sent" row is waiting on.
  if (submissionNotificationId) {
    params['submission_notification'] = submissionNotificationId;
  }

  const response = await client.post(`/api/initiated-form/${id}/store-submission/`, data, {
    params,
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });

  return response.data;
};

// The PDF of a "Sent" row's form as its on-behalf modal holds it (`body.data` = the
// modal's fields). Outside the shared `cancel`: printing must not cut off a submit.
export const getOnBehalfFormPDF = async (id, submissionNotificationId, body) => {
  return await client.post(`/api/initiated-form/${id}/print-on-behalf/`, body, {
    params: { submission_notification: submissionNotificationId },
    responseType: 'blob',
  });
};

export const getFormAutoFillingVariablesService = async (id) => {
  const response = await client.get(`/api/corporate-library/forms/${id}/auto-filling-variables/`);

  return response;
};

export const getGeneralFormAutoFillingVariablesService = async (id) => {
  const response = await client.get(`/api/general-library/forms/${id}/auto-filling-variables/`);

  return response;
};

export const updateGeneralFormAutoFillingVariableService = async (id, data) => {
  if (autoFillingVariablesCancel !== undefined) {
    autoFillingVariablesCancel();
  }

  const response = await client.put(`/api/general-library/forms/${id}/update-auto-filling-variables/`, data, {
    cancelToken: new CancelToken(function executor(c) {
      autoFillingVariablesCancel = c;
    }),
  });

  return response;
};

export const updateFormAutoFillingVariableService = async (id, data) => {
  if (autoFillingVariablesCancel !== undefined) {
    autoFillingVariablesCancel();
  }

  const response = await client.put(`/api/corporate-library/forms/${id}/update-auto-filling-variables/`, data, {
    cancelToken: new CancelToken(function executor(c) {
      autoFillingVariablesCancel = c;
    }),
  });

  return response;
};
